<script>
import Notification from "../reUse/Notification.vue";
export default {
  components: {
    Notification
  },
  emits: ['odjava'],
  data() {
    return {
      ime: '',
      priimek: '',
      email: '',
      telefon: '',
      password: '',
      pass_conf: '',
      ShowNoti: false,
      text: '',
      types: '',
      soglasje: false
    }
  },
  methods: {
    handleRegistration() {
      if (this.ime !== '' && this.priimek !== '' && this.email !== '' && this.tel !== '' && this.password !== '') {
        var podatki = new URLSearchParams();
        podatki.append('ime', this.ime);
        podatki.append('priimek', this.priimek);
        podatki.append('email', this.email);
        podatki.append('tel', this.telefon);
        podatki.append('password', this.pasword);
        if (this.pass_conf === this.password) {
          axios.post('./api/registracija/', podatki, {withCredentials: true}).then((response) => {
            this.$router.push('/');
          }).catch((error) => {
            if (napaka.response.status === 401) {
              this.$router.push('/Logout');
            }
            if (napaka.response.data.napaka !== undefined) {
              this.text = 'Napaka pri vnašanju podatkov. ' + napaka.response.data.napaka;
            } else {
              this.text = 'Napaka pri vnašanju podatkov.';
            }
            this.types = 'Napaka';
            this.ShowNoti = true;
          })
        } else {
          // alert('Password mismatch');
          this.text = ("Gesli se ne ujemata!");
          this.types = "Napaka";
          this.ShowNoti = true;
        }
      } else {
        // alert('Napaka pri registraciji, preveri če si izpolnil vsa polja!');
        this.text = ("Napaka pri registraciji, preveri če si izpolnil vsa polja!");
        this.types = "Napaka";
        this.ShowNoti = true;
      }

    }
  }
}
</script>
<template>
  <div class="upper-cloud border-bottom-0 rounded-bottom-4 p-2">
    <button class="p-2 btn-back" @click.prevent="$router.push('/')"><i class="fas fa-arrow-left fa-2x"></i></button>
    <h4 class="d-flex justify-content-center text-white">SKY-SCRIBE</h4>
    <h5 class="d-flex justify-content-center text-white">ČLANSTVO</h5>
  </div>
  <div class="container p-2">
    <Transition name="fade">
      <Notification v-if="ShowNoti" :message="this.text" :type="this.types" @closeNotification="ShowNoti = false" />
    </Transition>
    <form @submit.prevent="handleRegistration">
      <div class="col-12">
        <label :class="{ hidden: ime.length > 0 }" class="label" for="ime">Ime</label>
        <input class="input border-0 rounded-4 p-1 fs-5" autocomplete="off" type="text" id="ime" v-model="ime" required />
      </div>
      <div class="col-12">
        <label :class="{ hidden: priimek.length > 0 }" class="label" for="priimek">Priimek</label>
        <input class="input border-0 rounded-4 p-2 fs-5" autocomplete="off" type="text" id="priimek" v-model="priimek" required />
      </div>
      <div class="col-12">
        <label :class="{ hidden: email.length > 0 }" class="label" for="email">Email</label>
        <input class="input border-0 rounded-4 p-2 fs-5" autocomplete="off" type="email" id="email" v-model="email" required />
      </div>
      <div class="col-12">
        <label :class="{ hidden: telefon.length > 0 }" class="label" for="telefon">Telefon</label>
        <input class="input border-0 rounded-4 p-2 fs-5" autocomplete="off" type="text" id="telefon" v-model="telefon" required />
      </div>
      <div class="col-12">
        <label :class="{ hidden: password.length > 0 }" class="label" for="password">Password</label>
        <input class="input border-0 rounded-4 p-2 fs-5" type="password" id="password" v-model="password" required />
      </div>
      <div class="col-12">
        <label :class="{ hidden: pass_conf.length > 0 }" class="label" for="pass_conf">Password confirmation</label>
        <input class="input border-0 rounded-4 p-2 fs-5" type="password" id="password" v-model="pass_conf" required />
      </div>
      <div class="m-2">
        <button class="btn btn-primary rounded-pill btn-add p-2 col-12" :disabled="!soglasje">Register</button>
      </div>
    </form>
    <!-- SOGLASJE -->
    <p><strong>Soglasje za obdelavo podatkov</strong><br>
      Z uporabo te aplikacije soglašate z obdelavo vaših osebnih podatkov v skladu s <a href="https://www.ip-rs.si/?id=105" target="_blank">Politiko zasebnosti</a>. Osebni podatki, ki jih zbiramo, bodo uporabljeni izključno za namene, določene v naši politiki zasebnosti. Prosimo, da jo preberete in se strinjate z njenimi pogoji, preden nadaljujete z uporabo aplikacije.</p>

    <label>
      <input type="checkbox" v-model="soglasje" required>
      Strinjam se z obdelavo osebnih podatkov v skladu s Politiko zasebnosti.
    </label>
    <!-- <div class="p-1">
        <p>Forgot password?</p>
    </div> -->
  </div>
</template>